import { View } from "react-native";
import React, { useState } from "react";
import Login from "./LoginForm";
import Signup from "./SignupForm";

interface Props {
  loginTitle: string;
  signupTitle: string;
  marketplace?: boolean;
  initialForm?: "login" | "signup";
}
const LoginOrSignupForm = (props: Props) => {
  const { loginTitle, signupTitle, marketplace, initialForm = "login" } = props;

  const [showLogin, setShowLogin] = useState(initialForm === "login");

  return (
    <View>
      {showLogin ? (
        <Login title={loginTitle} onSignupClick={() => setShowLogin(false)} />
      ) : (
        <Signup
          title={signupTitle}
          marketplace={marketplace}
          onLoginClick={() => setShowLogin(true)}
        />
      )}
    </View>
  );
};

export default LoginOrSignupForm;
